import { SystemIcon } from '@helpers/icons';
import { useForm } from '@hooks/useForm';
import Button from '@stories/Components/Buttons/Button/Button';
import FormField from '@stories/Components/Misc/Forms/FormField';
import FormSection from '@stories/Components/Misc/Forms/FormSection';
import CheckboxList, { CheckboxListOption, } from '@stories/Components/Misc/Forms/Inputs/CheckboxList/CheckboxList';
import Textbox from '@stories/Components/Misc/Forms/Inputs/Textbox/Textbox';
import isEqual from 'lodash/isEqual';
import * as React from 'react';
import S from './MortgageProductFilters.styles';
const MortgagesProductFilters = (props) => {
    const { onSubmit, useReactHookFormReturn: { register, setValue, formState: { errors }, handleSubmit, watch, }, } = useForm({
        defaultValues: props.values,
        endpoint: props.redirect ?? '',
        mode: 'querystring',
    });
    const [cachedValues, setCachedValues] = React.useState(props.values ?? {});
    const [ltvRate, setLtvRate] = React.useState();
    const formValues = watch();
    React.useEffect(() => {
        if (props.values && !isEqual(props.values, cachedValues)) {
            setCachedValues(props.values);
            if (props.values?.purchasePrice)
                setValue('purchasePrice', props.values.purchasePrice);
            if (props.values?.depositAmount)
                setValue('depositAmount', props.values.depositAmount);
            if (props.values?.rateType)
                setValue('rateType', props.values.rateType);
        }
    }, [props.values]);
    React.useEffect(() => {
        if (formValues.purchasePrice &&
            formValues.depositAmount &&
            !isNaN(formValues.purchasePrice) &&
            !isNaN(formValues.depositAmount)) {
            setLtvRate(((formValues.purchasePrice - formValues.depositAmount) / formValues.purchasePrice) * 100);
        }
        else {
            setLtvRate(undefined);
        }
    }, [formValues.purchasePrice, formValues.depositAmount]);
    return (React.createElement(S.Container, { onSubmit: props.onSubmit !== undefined
            ? handleSubmit((formValues, event) => {
                event.preventDefault();
                props.onSubmit?.(formValues);
            })
            : onSubmit },
        React.createElement(FormSection, { title: props.translations?.['listings.mortgages.filters.purchasePrice.fieldset'] },
            React.createElement(FormField, { label: props.translations?.['listings.mortgages.filters.purchasePrice'], name: "purchasePrice", error: errors.purchasePrice },
                React.createElement(Textbox, { prefix: "\u00A3", ...register('purchasePrice', {
                        required: props.translations?.['listings.mortgages.filters.purchasePrice.error'] ?? false,
                        validate: (value) => {
                            if (value && isNaN(value)) {
                                return props.translations?.['listings.mortgages.filters.purchasePrice.errorType'];
                            }
                            return true;
                        },
                    }), setValue: (value) => setValue('purchasePrice', Number(value)), ...(props.values?.purchasePrice
                        ? { initialValue: props.values.purchasePrice.toLocaleString() }
                        : {}) }))),
        React.createElement(FormSection, { title: props.translations?.['listings.mortgages.filters.depositAmount.fieldset'] },
            React.createElement(FormField, { label: props.translations?.['listings.mortgages.filters.depositAmount'], name: "depositAmount", error: errors.depositAmount },
                React.createElement(Textbox, { prefix: "\u00A3", ...register('depositAmount', {
                        required: props.translations?.['listings.mortgages.filters.depositAmount.error'] ?? false,
                        validate: (value) => {
                            if (value && isNaN(value)) {
                                return props.translations?.['listings.mortgages.filters.depositAmount.errorType'];
                            }
                            return true;
                        },
                    }), setValue: (value) => setValue('depositAmount', Number(value)), ...(props.values?.depositAmount
                        ? { initialValue: props.values.depositAmount.toLocaleString() }
                        : {}) }))),
        ltvRate && (React.createElement(S.LoanToValue, null,
            props.translations?.['listings.mortgages.filters.loanToValue'],
            " ",
            ltvRate.toFixed(2),
            "%",
            props.translations?.['listings.mortgages.filters.loanToValue.tooltip'] && (React.createElement(S.Info, null,
                React.createElement(S.InfoButton, { "aria-label": props.translations?.['global.tooltip.label'], "aria-describedby": `mortgage-filter-ltv-tooltip`, onClick: (e) => e.preventDefault() }, "?"),
                React.createElement(S.Tooltip, { id: `mortgage-filter-ltv-tooltip`, role: "tooltip" }, props.translations?.['listings.mortgages.filters.loanToValue.tooltip']))))),
        React.createElement(FormSection, { title: props.translations?.['listings.mortgages.filters.rateType.fieldset'] },
            React.createElement(FormField, { label: props.translations?.['listings.mortgages.filters.rateType'], error: errors.rateType },
                React.createElement(CheckboxList, { layout: "horizontal" },
                    React.createElement(CheckboxListOption, { value: "fixed", ...register('rateType', {
                            required: props.translations?.['listings.mortgages.filters.rateType.error'] ?? false,
                        }) }, props.translations?.['listings.mortgages.filters.rateType.fixed']),
                    React.createElement(CheckboxListOption, { value: "variable", ...register('rateType', {
                            required: props.translations?.['listings.mortgages.filters.rateType.error'] ?? false,
                        }) }, props.translations?.['listings.mortgages.filters.rateType.variable'])))),
        React.createElement(S.ButtonWrapper, null,
            props.cancelLabel && (React.createElement(Button, { buttonType: "default", onClick: (event) => {
                    event.preventDefault();
                    setValue('purchasePrice', cachedValues.purchasePrice);
                    setValue('depositAmount', cachedValues.depositAmount);
                    setValue('rateType', cachedValues.rateType);
                    props.onCancel?.();
                }, icon: SystemIcon.None, disabled: isEqual(formValues, cachedValues) }, props.cancelLabel)),
            React.createElement(Button, { buttonType: "default", type: "submit" }, props.submitLabel))));
};
export default MortgagesProductFilters;
